import { useNavigate } from "react-router-dom";
import { useNewsResource } from "../../../news/hooks/useNewsResource";
import { ROUTES } from "../../../../routes/routes";

export const useNewsTab = () => {
  const newsResource = useNewsResource();

  const navigate = useNavigate();

  const handleOnRegisterNew = () => {
    navigate(ROUTES.NEWS.REGISTER);
  };

  return {
    newsResource,
    handleOnRegisterNew,
  };
};

